import React from 'react';
import { testimonials } from '../data/drum';
export function Testimonials() {
  // Hidden until authentic DRUM READY reviews are added in data/drum.ts
  if (testimonials.length === 0) return null;
  return <section className="w-full border-t border-slate-900/10 bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-273" data-mp="3fyvyycq5phc5">
      <div className="mx-auto max-w-6xl" data-id="element-274" data-mp="3b1chl3y5wofz">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-275" data-mp="3ayi11ni9rnru">
          What <em className="text-red-700" data-id="element-276" data-mp="36wmqdseg7y1e">teachers</em> say
        </h2>

        <div className="mt-14 grid gap-10 border-t border-slate-900/15 pt-10 sm:grid-cols-3" data-id="element-277" data-mp="31ybgjho5lnj6">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col" data-id="element-278" data-mp="2x2w5sylg07qz">
              <div className="text-sm text-amber-500" aria-label="5 out of 5 stars" data-id="element-279" data-mp="2s39pggabibdy">
                <span aria-hidden="true" data-id="element-280" data-mp="v8dmbo8h2gdg">★★★★★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-serif text-2xl leading-snug text-slate-900" data-id="element-281" data-mp="q9tyfiabiuig">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-6 text-sm" data-id="element-282" data-mp="h4n6uketiff5">
                <span className="font-semibold text-slate-900" data-id="element-283" data-mp="m5b4hoxjxuic">{item.name}</span>
                <span className="text-slate-900/60" data-id="element-284" data-mp="780lluikxmcl"> — {item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}